"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkQJK5AMYXjs = require('./chunk-QJK5AMYX.js');var _chunkPOE2IUJUjs = require('./chunk-POE2IUJU.js');var _chunkMQ5AGG7Cjs = require('./chunk-MQ5AGG7C.js');var _chunkCE7AVXFIjs = require('./chunk-CE7AVXFI.js');var _chunkTQAB3Z6Ajs = require('./chunk-TQAB3Z6A.js');var _react = require('react'); var _react2 = _interopRequireDefault(_react);var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var T=_styled2.default.a`
  display: flex;
  flex-flow: column;
  width: ${e=>e.theme.measurements.spacing(208)};
  padding: ${e=>e.theme.measurements.spacing(8)};
  gap: ${e=>e.theme.measurements.spacing(8)};
  border-radius: ${e=>e.theme.measurements.shape(2)};
  border: ${e=>e.theme.measurements.spacing(.5)} solid
    ${e=>e.theme.palette.DIVIDER};
  background: ${e=>e.theme.palette.BASE_ONE};
  color: ${e=>e.theme.palette.SECONDARY};
  font-size: ${e=>e.theme.measurements.spacing(7)};
`,C=_styled2.default.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${e=>e.theme.measurements.spacing(2)};
  max-width: 100%;
`,L=_styled2.default.div`
  display: flex;
  align-items: center;
  gap: ${e=>e.theme.measurements.spacing(4)};
`,S=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.b)`
  text-transform: uppercase;
  font-size: ${e=>e.theme.measurements.spacing(6)};
  line-height: ${e=>e.theme.measurements.spacing(6)};
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`,D=_styled2.default.call(void 0, _chunkPOE2IUJUjs.b)`
  font-size: ${e=>e.theme.measurements.spacing(6)};
  line-height: ${e=>e.theme.measurements.spacing(6)};
  font-weight: 700;
`,z=_styled2.default.div`
  display: flex;
  flex-flow: column;
  gap: ${e=>e.theme.measurements.spacing(4)};
  flex: 3;
  max-width: 75%;
`,O=_styled2.default.div`
  max-width: ${e=>e.theme.measurements.spacing(41)};
  display: flex;
  justify-content: flex-end;
  flex: 1;
`,W=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.b)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`,h=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.b)`
  color: ${e=>e.theme.palette.SECONDARY};
`,j=_styled2.default.div`
  display: flex;
  align-items: center;
`,F=_styled2.default.div`
  display: flex;
  align-items: center;
  gap: ${e=>e.theme.measurements.spacing(2)};
  justify-content: flex-start;
  flex: 2.5;

  img {
    max-height: ${e=>e.theme.measurements.spacing(10)};
  }
`,Y=_styled2.default.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1.5;
`,M=_styled2.default.call(void 0, _chunkQJK5AMYXjs.a)`
  align-items: center;
  svg {
    color: ${e=>e.theme.palette.SECONDARY};
  }
`,V=_react2.default.forwardRef((e,y)=>{let{href:B="",title:s,educatorName:v,nAttempted:E=0,nPeopleAttempted:P=0,langLabel:m,attemptString:x,topicName:l,topicColor:$="#8873FF",nTotal:p=0,state:r="locked",className:w,ariaLabel:I,dataTestId:A,EducatorImage:d,PeopleAttemptedAnimation:N,actionButton:i,onClick:R,as:b}=e;return _jsxruntime.jsxs.call(void 0, T,{as:b,href:B,ref:y,title:s,"aria-label":I,"data-testid":A,onClick:r!=="locked"?R:void 0,className:`${w||""} aquilla-practice-by-educator practice-by-educator`,children:[_jsxruntime.jsxs.call(void 0, C,{children:[_jsxruntime.jsxs.call(void 0, z,{children:[_jsxruntime.jsxs.call(void 0, L,{children:[!!m&&_jsxruntime.jsx.call(void 0, D,{as:"div",variant:"default",size:"small",children:m}),!!l&&_jsxruntime.jsx.call(void 0, S,{as:"div",variant:"h6",color:$,children:l})]}),_jsxruntime.jsx.call(void 0, W,{variant:"h5",as:"div",children:s}),_jsxruntime.jsx.call(void 0, h,{variant:"p2",as:"div",children:v}),p?_jsxruntime.jsxs.call(void 0, h,{variant:"p2",as:"div",children:[E||0," of ",p," attempted"]}):""]}),!!d&&_jsxruntime.jsx.call(void 0, O,{children:d})]}),_jsxruntime.jsx.call(void 0, _chunkCE7AVXFIjs.b,{orientation:"horizontal"}),_jsxruntime.jsxs.call(void 0, j,{children:[_jsxruntime.jsxs.call(void 0, F,{children:[N||"",x||`${P||"0"} have attempted`]}),_jsxruntime.jsxs.call(void 0, Y,{children:[i||"",!i&&r==="locked"?_jsxruntime.jsx.call(void 0, M,{disabled:!0,startIcon:_jsxruntime.jsx.call(void 0, _chunkTQAB3Z6Ajs.b,{}),children:"Locked"}):"",!i&&r==="start"?_jsxruntime.jsx.call(void 0, _chunkQJK5AMYXjs.a,{variant:"primary",children:"Start"}):"",!i&&r==="view"?_jsxruntime.jsx.call(void 0, _chunkQJK5AMYXjs.a,{variant:"secondary",children:"View"}):"",!i&&r==="resume"?_jsxruntime.jsx.call(void 0, _chunkQJK5AMYXjs.a,{variant:"secondary",children:"Resume"}):""]})]})]})}),U= exports.a =V;exports.a = U;
